export const DUMMY_MEMBERS = [
  { teamName: 'TherapEase', userName: '권가은' },
  { teamName: 'TherapEase', userName: '김서연' },
  { teamName: 'bariBari', userName: '오예린' },
  { teamName: 'bariBari', userName: '최민주' },
  { teamName: 'Hooking', userName: '장효신' },
  { teamName: 'Hooking', userName: '김문기' },
  { teamName: 'DanSupport', userName: '노수진' },
  { teamName: 'DanSupport', userName: '신유진' },
  { teamName: 'Repick', userName: '이예지' },
  { teamName: 'Repick', userName: '배성준' },
];

export const DUMMY_PART_VOTE_RESULT = [
  { teamName: 'TherapEase', userName: '권가은', voteCount: 5 },
  { teamName: 'TherapEase', userName: '김서연', voteCount: 5 },
  { teamName: 'bariBari', userName: '오예린', voteCount: 5 },
  { teamName: 'bariBari', userName: '최민주', voteCount: 5 },
  { teamName: 'Hooking', userName: '장효신', voteCount: 5 },
  { teamName: 'Hooking', userName: '김문기', voteCount: 5 },
  { teamName: 'DanSupport', userName: '노수진', voteCount: 5 },
  { teamName: 'DanSupport', userName: '신유진', voteCount: 5 },
  { teamName: 'Repick', userName: '이예지', voteCount: 5 },
  { teamName: 'Repick', userName: '배성준', voteCount: 5 },
];
